import Loader from './components/Loader/FullScreen'
import AppRoutes from './routes'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { Suspense } from 'react'
import { getCookieValue } from './helpers'

const App = () => {

  const doc = document.getElementsByClassName('_form-wrapper')

  const hasCookie = getCookieValue("_form_6_");

  if (doc && doc[0]) {

    let el = doc[0]

    el.style.display = 'none'

  }

  const displayPopup = (e) => {

    if( e.clientY < 0 ){

      if (doc && doc[0]) {

        let el = doc[0]
    
        el.style.display = 'block'
    
      }

    }

  }

  document.addEventListener("mouseleave", displayPopup, false);

  if (hasCookie) {

    document.removeEventListener('mouseleave', displayPopup)

  }

  return (
    <Suspense fallback={<Loader suspense />}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Suspense>
  );

}

export default App;
